// TODO: Update to be for goals for this team specifically
const getTopScorer = (players) => {
  let topScorer = [...players].sort((a, b) => a.goals - b.goals).pop()
  return topScorer.goals > 0 ? topScorer : null
}
export default getTopScorer
